import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ROUTES } from "../../sidebar/sidebar.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { FormBuilder } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { SessionService } from "../../services/session.service";
import { LoginService } from "../../services/login.service";
import { Site } from "../../models/site";
import { UserService } from "app/services/user.service";
import { QueryModel } from "app/models/queryModel";
import { ToastrService } from "ngx-toastr";
import { CookieService } from "ngx-cookie-service";

@Component({
  moduleId: module.id,
  selector: "navbar-cmp",
  templateUrl: "navbar.component.html",
})
export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  sites: Site[];
  SiteId = -1;
  loginService: LoginService;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;
  siteData: any = [];
  selectedValue: Site;
  selectedId: number;
  user: any;
  queryModelSetScope: QueryModel = new QueryModel();
  public isCollapsed = true;
  @ViewChild("navbar-cmp", { static: false }) button;

  userData = null;

  constructor(
    location: Location,
    private renderer: Renderer2,
    private element: ElementRef,
    private router: Router,
    public fb: FormBuilder,
    public translate: TranslateService,
    private sessionService: SessionService,
    private userService: UserService,
    private toastr: ToastrService,
    private cookieService: CookieService
  ) {
    if(cookieService.get("UserData") !== ""){
      this.userData = JSON.parse(cookieService.get("UserData"));
    }

    this.location = location;
    this.sites = sessionService.getSites();
    this.siteData = this.sites;
    this.selectedId = sessionService.getSiteId();
    // this.UserName = sessionService.getUserName();
    this.user = this.sessionService.getUserObject();

    if (this.selectedId == null) {
      //console.log("Please set the scope.");
      this.queryModelSetScope.request.query = "proc_web_set_scope";
      this.queryModelSetScope.request.parameters = [0];
      this.userService
        .GetMethod(this.queryModelSetScope)
        .subscribe((response) => {
          // if(response.body.data[0].result == 1)
          // {
          //   this.toastr.info('Scope has been set successfully', 'Info');
          //   this.delay(1000);
          //   location.reload();
          // }
          // else
          // {
          //   this.toastr.error('Scope has not been set successfully', 'Error');
          // }
          //console.log("Response Set:" + JSON.stringify(response)) ;
        });
    }
    //console.log("sites in bar:" + JSON.stringify( this.sites));
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;

    document.addEventListener("mouseup", function (e: any) {
      var container = document.getElementById("dropdown-submenu");
      var container1 = document.getElementById("dropdown-submenu-conf");
      if (!container?.contains(e.target) || !container1?.contains(e.target)) {
        if (!container == null) {
          return;
        } else {
          if (container == null) return;
          container.style.display = "none";
          if (container1 == null) return;

          container1.style.display = "none";
        }
      }
    });
  }

  siteDataForm = this.fb.group({
    name: [""],
  });
  ngOnInit() {
    this.listTitles = ROUTES.filter((listTitle) => listTitle);
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName("navbar-toggle")[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
    });
  }
  trackSiteById(index, site) {
    return site.id;
  }
  onChange(eventSite) {
    //console.log("Depot:" + eventSite.target.value) ;
    this.sessionService.setSiteId(eventSite.target.value);
    this.queryModelSetScope.request.query = "proc_web_set_scope";
    this.queryModelSetScope.request.parameters = [eventSite.target.value];
    this.userService
      .GetMethod(this.queryModelSetScope)
      .subscribe((response) => {
        if (response.body.data[0].result == 1) {
          this.toastr.info("Scope has been set successfully", "Info");
          this.delay(1000);
          location.reload();
        } else {
          this.toastr.error("Scope has not been set successfully", "Error");
        }

        //console.log("Response Set:" + JSON.stringify(response)) ;
      });
  }

  private delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }
    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return "Dashboard";
  }
  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }
  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const html = document.getElementsByTagName("html")[0];
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );
    setTimeout(function () {
      toggleButton.classList.add("toggled");
    }, 500);

    html.classList.add("nav-open");
    if (window.innerWidth < 991) {
      mainPanel.style.position = "fixed";
    }
    this.sidebarVisible = true;
  }
  sidebarClose() {
    const html = document.getElementsByTagName("html")[0];
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );
    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = "";
      }, 500);
    }
    //this.toggleButton.classList.remove("toggled");
    this.sidebarVisible = false;
    html.classList.remove("nav-open");
  }
  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName("nav")[0];
    //console.log(navbar);
    if (!this.isCollapsed) {
      navbar.classList.remove("navbar-transparent");
      navbar.classList.add("bg-white");
    } else {
      navbar.classList.add("navbar-transparent");
      navbar.classList.remove("bg-white");
    }
  }

  onSubmit() {
    alert(JSON.stringify(this.siteDataForm.value));
  }

  changeLanguage(val) {
    this.translate.use(val);
    location.reload();
  }

  LogOut() {
    this.sessionService.logout();
    this.router.navigateByUrl("/login");
  }

  showSubMenu() {
    var on = document.getElementById("dropdown-submenu");
    var off = document.getElementById("dropdown-submenu");
    if (on.style.display === "none") {
      off.style.display = "none";
      on.style.display = "block";
    } else {
      off.style.display = "block";
      on.style.display = "none";
    }
  }

  closeSubMenu() {
    var menustyle = document.getElementById("dropdown-submenu");
    menustyle.style.display = "none";
  }
}
